export default "__VITE_ASSET__936a24db__"